import * as React from 'react'
import * as PropTypes from 'prop-types'
import moment from 'moment'
import { Rule } from 'glamor'

import { withTheme, IWithThemeProps } from '../../theme'

import { Flex } from '../flex'

import { DatepickerMonth } from './datepicker-month'
import { FormattedMessage, defineMessages } from 'react-intl'

const messages = defineMessages({
  start: {
    id: 'ui-kit.daterange-picker.start',
    defaultMessage: 'Start',
  },
  end: {
    id: 'ui-kit.daterange-picker.end',
    defaultMessage: 'End',
  },
})

interface IDaterangePickerProps {
  timeperiod: {
    fromDate?: moment.Moment | null
    toDate?: moment.Moment | null
  }
  onTimeperiodChange: (timeperiod: { fromDate?: moment.Moment | null; toDate?: moment.Moment | null }) => void
  lastSelectableDate?: moment.Moment
  firstSelectableDate?: moment.Moment
  style?: Rule
  locale: string
  allowOpenEnds?: boolean
}

export const DaterangePicker = withTheme(
  class DaterangePicker extends React.Component<IDaterangePickerProps & IWithThemeProps> {
    static propTypes = {
      timeperiod: PropTypes.object.isRequired,
      lastSelectableDate: PropTypes.object as any,
      firstSelectableDate: PropTypes.object as any,
      style: PropTypes.object,
      locale: PropTypes.string.isRequired,
      onTimeperiodChange: PropTypes.func.isRequired,
      allowOpenEnds: PropTypes.bool,
    }

    static defaultProps = {
      allowOpenEnds: true,
    }

    onStartDateSelected = (newDate: moment.Moment) => {
      return this.onDateSelected(newDate, 'fromDate')
    }

    onEndDateSelected = (newDate: moment.Moment) => {
      this.onDateSelected(newDate, 'toDate')
    }

    onDateSelected = (newDate: moment.Moment, position: 'fromDate' | 'toDate') => {
      const oldPosition = this.props.timeperiod[position]
      const selectedDate = moment(newDate)
      const newPosition =
        oldPosition && oldPosition.isSame(selectedDate)
          ? this.props.allowOpenEnds
            ? null
            : selectedDate
          : selectedDate
      newPosition &&
        this.props.onTimeperiodChange({
          ...this.props.timeperiod,
          [position]: newPosition,
        })
    }
    render() {
      const { locale, firstSelectableDate, lastSelectableDate, timeperiod, theme, style } = this.props
      return (
        <Flex row style={style}>
          <DatepickerMonth
            firstSelectableDate={firstSelectableDate}
            isFromMonth
            lastSelectableDate={lastSelectableDate}
            locale={locale}
            onDateSelected={this.onStartDateSelected}
            style={{ marginRight: theme.settings.spacing.large }}
            timeperiod={timeperiod}
            title={<FormattedMessage {...messages.start} />}
          />
          <DatepickerMonth
            firstSelectableDate={firstSelectableDate}
            isFromMonth={false}
            lastSelectableDate={lastSelectableDate}
            locale={locale}
            onDateSelected={this.onEndDateSelected}
            timeperiod={timeperiod}
            title={<FormattedMessage {...messages.end} />}
          />
        </Flex>
      )
    }
  }
)
